(ns app.front.view.admin.commands.authorize-sibling-groups
  (:require [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-candidates
  (fn [_ _]
    {:comm/command {:command    :admin.sibling-auths/get-missing-authorizations
                    :method     :get
                    :on-success [::fetch-candidates.success]}}))

(rf/reg-event-fx ::fetch-candidates.success
  (fn [{:keys [db]} [_ status resp]]
    (when (= 200 status)
      {:db (-> db
               (assoc ::candidates resp))})))

(rf/reg-sub ::candidates
  :-> ::candidates)

(rf/reg-event-fx ::grant-permissions
  (fn [_ [_ from-group to-group expected-count]]
    {:comm/command {:command    :admin.sibling-auths/add-missing-authorizations
                    :method     :post
                    :data       (util/mmap from-group to-group expected-count)
                    :notify     {:success "Successfully added auths"}
                    :on-success [::fetch-candidates]}}))

(defn add-auths-btn [[{to-id :db/id to-group :group/name}
                      {from-id :db/id from-group :group/name}
                      ws-count]]
  [ui/modal-confirmation-button
   {:id                  (str to-id "-from-" from-id)
    :trigger-button-text "Grant"
    :tr                  (<sub [:tr])
    :text-button?        true
    :on-yes-click        #(>evt [::grant-permissions from-id to-id ws-count])}
   [:span "Are you sure you want to grant 'guest-authority' permission to "
    [:span.bold to-group]
    " for "
    ws-count
    " workspaces of "
    [:span.bold from-group]]])

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Authorize sibling group"} match)
   [:section
    [ui/help
     (str "When multiple authority groups handle different permit types of one municipality, "
          "all of them get granted 'guest-authority' permissions on all workspaces of that "
          "municipality. However, this is not done retroactively when a new authority group "
          "is created.\n"
          "You can use this tool to grant those authorizations for workspaces created before "
          "a group was created.")]

    [ui-table/modern-responsive-table
     {:items (<sub [::candidates])
      :cols  [["WS owner group" (comp :group/name second)]
              ["Group missing auth" (comp :group/name first)]
              ["Nr workspaces" last {:flex "0 1 150px"}]
              ["" add-auths-btn {:flex "0 1 75px"}]]}]]])

(def route
  {:name        :view/admin.commands.authorize-sibling-groups
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-candidates]))}]})
